module.exports = __webpack_public_path__ + "img/green-circle.6a4dc4c9.svg";